<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker, checkbox, radio } from 'vue-strap';

  export default {
    components: { checkbox, datepicker, radio },
    props: {
      itemSolicitacao: {
        required: true
      },
      manterObservacao: {
        default: true,
        type: Boolean,
      },
      produtos: {
        required: true
      },
      tiposProdutos: {
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    computed: {
      apenasIda() {
        return this.itemSolicitacao.apenasIda === 'true';
      },
      observacaoItemCompraContador: function() {
        let quantidadeCaracteres = this.itemSolicitacao.observacaoItemCompra ?
            this.itemSolicitacao.observacaoItemCompra.length : 0;

        return 500 - quantidadeCaracteres;
      }
    },
    methods: {
      validar() {
        return this.$validator.validateAll();
      },
      limparDadosVolta() {
        if (this.apenasIda) {
          this.itemSolicitacao.origemVolta = '';
          this.itemSolicitacao.destinoVolta = '';
          this.itemSolicitacao.dataVolta = '';
          this.itemSolicitacao.horarioVolta = '';
          this.itemSolicitacao.horarioChegadaVolta = '';
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        $('.datepicker input').attr('readonly', '');
        $('.radios .radio')
          .css('display', 'inline')
          .eq(0).css('margin-right', '10px');
      });
    },
    watch: {
      'apenasIda': 'limparDadosVolta',
    }
  }
</script>

<template>
    <div>
        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('tipoProduto')}">
                    <label class="control-label" for="tipoProduto">Tipo de produto</label>

                    <select class="form-control"
                            id="tipoProduto"
                            v-model="itemSolicitacao.idTipoProduto"
                            data-vv-name="tipoProduto"
                            data-vv-as="tipo de produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="tipoProduto.idTipoProduto"
                                v-for="tipoProduto in tiposProdutos">
                            {{ tipoProduto.nomeTipoProduto }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('tipoProduto')">{{ errors.first('tipoProduto') }}</p>
                </div>
            </div>
        </div>

        <div class="row" v-if="configuracao.obrigatorioSelecionarProduto">
            <div class="col-md-12">
                <div class="form-group required" :class="{'has-error': errors.has('produto')}">
                    <label class="control-label" for="produto">Produto</label>

                    <select class="form-control"
                            id="produto"
                            v-model="itemSolicitacao.idProduto"
                            data-vv-name="produto"
                            data-vv-as="produto"
                            v-validate="'required'">
                        <option value="">Selecione...</option>
                        <option :value="produto.idProduto"
                                v-for="produto in produtos">
                            {{ produto.nome }}
                        </option>
                    </select>

                    <p class="text-danger" v-show="errors.has('produto')">{{ errors.first('produto') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div :class="[configuracao.utilizarValorEstimado ? 'col-xs-6' : 'col-xs-12']">
                <div class="form-group required" :class="{'has-error': errors.has('quantidade')}">
                    <label class="control-label" for="quantidade">Quantidade</label>

                    <input type="text"
                           class="form-control text-right"
                           id="quantidade"
                           v-model="itemSolicitacao.quantidade"
                           data-vv-name="quantidade"
                           v-validate="'required|not_zero'"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('quantidade')">{{ errors.first('quantidade') }}</p>
                </div>
            </div>

            <div class="col-xs-6" v-if="configuracao.utilizarValorEstimado">
                <div class="form-group required" :class="{'has-error': errors.has('valorEstimado')}">
                    <label class="control-label" for="valor-estimado">Valor unitário estimado (R$)</label>

                    <input type="text"
                           class="form-control text-right"
                           id="valor-estimado"
                           v-model="itemSolicitacao.valorEstimado"
                           data-vv-name="valorEstimado"
                           v-validate="'required|not_zero'"
                           data-vv-as="valor estimado"
                           v-mascara="'moeda'">

                    <p class="text-danger" v-show="errors.has('valorEstimado')">{{ errors.first('valorEstimado') }}</p>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('descricaoMaterial')}">
                    <label class="control-label" for="descricao-material">Informar dados do passageiro (Nome completo, CPF, telefone e e-mail)</label>

                    <textarea class="form-control"
                              id="descricao-material"
                              v-model="itemSolicitacao.descricao"
                              v-validate="'required'"
                              data-vv-name="descricaoMaterial"
                              data-vv-as="descrição do material/serviço">
          </textarea>

                    <p class="text-danger" v-show="errors.has('descricaoMaterial')">{{ errors.first('descricaoMaterial') }}</p>
                </div>
            </div>
        </div>

        <h3 class="m-t-none m-b">Dados da Viagem</h3>
        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group radios">
                    <radio
                        v-model="itemSolicitacao.apenasIda"
                        selected-value="false"
                        type="success">
                        Ida e volta
                    </radio>

                    <radio
                        v-model="itemSolicitacao.apenasIda"
                        selected-value="true"
                        type="success">
                        Apenas ida
                    </radio>
                </div>
            </div>
        </div>

        <h4 class="m-t-none m-b">Ida</h4>
        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <div class="col-lg-3">
                <div class="form-group required" :class="{'has-error': errors.has('origemIda')}">
                    <label class="control-label">Origem</label>

                    <input class="form-control"
                           type="text"
                           v-model="itemSolicitacao.origemIda"
                           data-vv-name="origemIda"
                           data-vv-as="origem"
                           v-validate="'required'"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('origemIda')">{{ errors.first('origemIda') }}</p>
                </div>
            </div>

            <div class="col-lg-3">
                <div class="form-group required" :class="{'has-error': errors.has('destinoIda')}">
                    <label class="control-label">Destino</label>

                    <input class="form-control"
                           type="text"
                           v-model="itemSolicitacao.destinoIda"
                           data-vv-name="destinoIda"
                           data-vv-as="destino"
                           v-validate="'required'"
                           maxlength="100">

                    <p class="text-danger" v-show="errors.has('destinoIda')">{{ errors.first('destinoIda') }}</p>
                </div>
            </div>

            <div class="col-lg-2">
                <div class="form-group required" :class="{'has-error': errors.has('dataIda')}">
                    <label class="control-label">Data</label>

                    <datepicker id="dataIda"
                                v-model="itemSolicitacao.dataIda"
                                format="dd/MM/yyyy"
                                placeholder="  /  /     "
                                lang="pt-BR"
                                data-vv-name="dataIda"
                                data-vv-as="data ida"
                                v-validate="'required|date_format:DD/MM/YYYY'">
                    </datepicker>

                    <p class="text-danger" v-show="errors.has('dataIda')">{{ errors.first('dataIda') }}</p>
                </div>
            </div>

            <div class="col-lg-2">
                <div class="form-group required" :class="{'has-error': errors.has('horarioIda')}">
                    <label class="control-label">Horário de saída</label>

                    <input id="horario-saida-ida"
                           class="form-control"
                           type="text"
                           v-mascara="'hora'"
                           v-model="itemSolicitacao.horarioIda"
                           data-vv-name="horarioIda"
                           data-vv-as="horário de saída"
                           v-validate="'required|date_format:HH:mm'">

                    <p class="text-danger" v-show="errors.has('horarioIda')">{{ errors.first('horarioIda') }}</p>
                </div>
            </div>

            <div class="col-lg-2">
                <div class="form-group required" :class="{'has-error': errors.has('horarioChegadaIda')}">
                    <label class="control-label">Horário de chegada</label>

                    <input id="horario-chegada-ida"
                           class="form-control"
                           type="text"
                           v-mascara="'hora'"
                           v-model="itemSolicitacao.horarioChegadaIda"
                           data-vv-name="horarioChegadaIda"
                           data-vv-as="horário de chegada"
                           v-validate="'required'">

                    <p class="text-danger" v-show="errors.has('horarioChegadaIda')">{{ errors.first('horarioChegadaIda') }}</p>
                </div>
            </div>
        </div>

        <div v-show="!apenasIda">
            <h4 class="m-t-none m-b">Volta</h4>
            <div class="hr-line-dashed margin-top-5"></div>

            <div class="row">
                <div class="col-lg-3">
                    <div class="form-group required" :class="{'has-error': errors.has('origemVolta')}">
                        <label class="control-label">Origem</label>

                        <input class="form-control"
                               type="text"
                               v-model="itemSolicitacao.origemVolta"
                               data-vv-name="origemVolta"
                               data-vv-as="origem"
                               v-validate="!apenasIda ? 'required' : ''"
                               maxlength="100">

                        <p class="text-danger" v-show="errors.has('origemVolta')">{{ errors.first('origemVolta') }}</p>
                    </div>
                </div>

                <div class="col-lg-3">
                    <div class="form-group required" :class="{'has-error': errors.has('destinoVolta')}">
                        <label class="control-label">Destino</label>

                        <input class="form-control"
                               type="text"
                               v-model="itemSolicitacao.destinoVolta"
                               data-vv-name="destinoVolta"
                               data-vv-as="destino"
                               v-validate="!apenasIda ? 'required' : ''"
                               maxlength="100">

                        <p class="text-danger" v-show="errors.has('destinoVolta')">{{ errors.first('destinoVolta') }}</p>
                    </div>
                </div>

                <div class="col-lg-2">
                    <div class="form-group required" :class="{'has-error': errors.has('dataVolta')}">
                        <label class="control-label">Data</label>

                        <datepicker id="dataVolta"
                                    v-model="itemSolicitacao.dataVolta"
                                    format="dd/MM/yyyy"
                                    placeholder="  /  /     "
                                    lang="pt-BR"
                                    data-vv-name="dataVolta"
                                    data-vv-as="data volta"
                                    v-validate="!apenasIda ? 'required|date_format:DD/MM/YYYY' : ''">
                        </datepicker>

                        <p class="text-danger" v-show="errors.has('dataVolta')">{{ errors.first('dataVolta') }}</p>
                    </div>
                </div>

                <div class="col-lg-2">
                    <div class="form-group required" :class="{'has-error': errors.has('horarioVolta')}">
                        <label class="control-label">Horário de saída</label>

                        <input id="horario-saida-volta"
                               class="form-control"
                               type="text"
                               v-mascara="'hora'"
                               v-model="itemSolicitacao.horarioVolta"
                               data-vv-name="horarioVolta"
                               data-vv-as="horário de saída"
                               v-validate="!apenasIda ? 'required|date_format:HH:mm' : ''">

                        <p class="text-danger" v-show="errors.has('horarioVolta')">{{ errors.first('horarioVolta') }}</p>
                    </div>
                </div>

                <div class="col-lg-2">
                    <div class="form-group required" :class="{'has-error': errors.has('horarioChegadaVolta')}">
                        <label class="control-label">Horário de chegada</label>

                        <input id="horario-chegada-volta"
                               class="form-control"
                               type="text"
                               v-mascara="'hora'"
                               v-model="itemSolicitacao.horarioChegadaVolta"
                               data-vv-name="horarioChegadaVolta"
                               data-vv-as="horário de chegada"
                               v-validate="!apenasIda ? 'required' : ''">

                        <p class="text-danger" v-show="errors.has('horarioChegadaVolta')">{{ errors.first('horarioChegadaVolta') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                    <div class="checkbox">
                        <checkbox @checked="$emit('update:manterObservacao', !manterObservacao)" :value="manterObservacao" type="primary">
                            Manter observação do item de compra (caso esta solicitação
                            demandar outros itens com a mesma observação)
                        </checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!configuracao.solCompraOcultarObservacoes">
            <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="observacao-item-compra">Outros detalhes (Restrições ou Condições Especiais) ({{ observacaoItemCompraContador }})</label>

                    <textarea class="form-control"
                              id="observacao-item-compra"
                              v-model="itemSolicitacao.observacaoItemCompra"
                              maxlength="500">
          </textarea>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormPassagemAerea.vue